/**
 * Created by esalazar on 9/27/17.
 */
(function() {
    'use strict';
    angular
        .module('soopkitchenApp')
        .factory('FileUploadService', FileUploadService);

    FileUploadService.$inject = [ 'Upload'];

    function FileUploadService( Upload ) {

        return {
            uploadFiles : uploadFiles,
            progressCallback: progressCallback
        };

        function progressCallback() {
            //Nothing at present
        }
        function uploadFiles(files, urlService, label, successCallback, errorCallback, progressCallback, desc) {
            if (files && files.length) {
                Upload.upload({
                    url: urlService,
                    data: {
                        files: files, label : label, description : desc
                    },
                    arrayKey:''
                }).then(successCallback, errorCallback, progressCallback);
            }
        }
    }
})();
